import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { DateHelper } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { AccountingFormTypes } from "models/formTypes";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer, useFilterContext } from "components/common";
import { useFinancialReportService } from "serviceHooks";
//#endregion

const BalanceReportAssetsSummaryLineChart: React.FC = () => {
  const financialReportService = useFinancialReportService();
  const { filter } = useFilterContext<AccountingFormTypes.FinancialReportFilter>();

  const generateLabels = (chartData?: WintSuperkollAPIModel.ReportWidget): string[] => {
    let labels = [""];
    if (chartData?.data?.length) {
      labels = DateHelper.getMonthsBetween(chartData.data[0].startDate, chartData.data[0].endDate).map((month) =>
        month.substring(0, 3)
      );
    }
    return labels;
  };

  return filter?.monthRange?.start && filter?.monthRange?.end ? (
    <ChartContainer
      chartAPIKey={GraphConstants.ChartKeys.BalanceReportAssetsSummaryLineWidget}
      customLabelsHandler={generateLabels}
      filterToAPIHandler={financialReportService.monthlyReportToAPIFilter}
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
      usePageFilter
    />
  ) : (
    <></>
  );
};

export default BalanceReportAssetsSummaryLineChart;
